import { Helpers } from '../../helpers';
import { IUnit } from '../../interfaces/iunit';
import { ForecastHorizontal } from '../forecast-horizontal';

export class UnitBase {
  UnitId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ForecastHorizontal_Unit?: Array<ForecastHorizontal> | null;

  constructor(item?: IUnit) {
    if (item) {

      this.UnitId = item.UnitId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ForecastHorizontal_Unit = Helpers.createClassArray(ForecastHorizontal, item.ForecastHorizontal_Unit);
    }
  }
}